
import {get_menus} from '@/api/menu.api'
import {load} from '@/utils'
import router from '@/router'
const state = {
    menus:[],         //菜单
    tags: [],
    routes:[],
    shrink: false,
}

const mutations = {
    set_menus(state,menus){
        state.menus = menus;
    },
    init_tags(state, menus) {
        let tags = cookie.get('tags');
        if (tags){
            state.tags = tags;
            let to = state.tags.find(t=>t.active);
            router.push({name:to.name});
            return;
        }
            
        
        let dashboard = menus.find(m => m.id == 0);
        state.tags.push({
            ...dashboard,
            active:true,
            close:false,
            default:true
        });
    },
    init_dynamic_routes(state,menus){
        for(let x of menus){
            x['component'] = load(x.view);
            if (x.children){
                for(let c of x.children){
                    c['component'] = load(c.view);
                }
            }
        }
        
        state.routes = state.menus;
        router.addRoutes(state.routes);
        // let tag = state.tags.find(t=>t.active);
        // router.push({name:tag.name});
       
    }
}
const actions = {

    /**
     * 折叠、展开 切换
     * @param {} param0 
     */
    toggle:({state})=>state.shrink=!state.shrink,

    load_menus:async ({commit,state})=>{
        // get menus from cookie . 
        let menus = cookie.get('menus');
        if (!menus){
            console.log('menus not  incluced in cookie. load from json file');
            menus = await get_menus();
            cookie.set('menus',menus);
        }
        commit('set_menus', menus);

        // initialise tag list;
        commit('init_tags', menus);

        cookie.set('tags',state.tags);

        commit('init_dynamic_routes',menus);
       
        return state.menus;
    },

    
    open({state},menu){
        
        let to_route = state.menus.find(r=>r.name==menu);
        if (!to_route){
            for(let m of state.menus){
                if (m.children){
                    to_route = m.children.find(r=>r.name==menu);
                    break;
                }
            }
        }
        console.log(to_route);
        for (let t of state.tags) {
             t.active = false;
        }
        let tag = state.tags.find(t=>t.name==menu);
       
        if (tag)
            tag.active = true;
        else
            state.tags.push({...to_route,active:true,default:false,close:true});
        cookie.set('tags', state.tags);
        router.push({name:menu});
    },
    clear({state}){
        let dashboard = state.tags[0];
        dashboard.active = true;
        state.tags = [dashboard];
    }
}

const getters = {
    menus: state => state.menus,
    shrink:state=>state.shrink,
    title:state=>state.shrink?option.mini_title:option.title,
    expand: state => state.shrink ? 'shrink':'expand',
    tags:state=>state.tags,
    dynamic_routes:state=>state.routes

}
export default {
    namespaced:true,
    state,mutations,actions,getters
}
